
<form class="flex flex-col text-sm gap-2" [formGroup]="updateProfileForm" (ngSubmit)="onSubmit()">
    <!-- Display Name -->
    <div class="flex flex-col gap-1">
        <div class="font-bold">
            Display Name
        </div>
        <input type="text" formControlName="displayName" class="bg-slate-100 p-1 shadow-sm" maxlength="128">
    </div>
    <!-- Location -->
    <div class="flex flex-row gap-2 items-center">
        <div>
            <svg class="w-4 h-4 text-slate-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
            </svg>
        </div>
        <div class="grow">
            <input type="text" formControlName="location" class="bg-slate-100 p-1 shadow-sm w-full" maxlength="128">
        </div>
    </div>
    <!-- Website -->
    <div class="flex flex-row gap-2 items-center">
        <div>
            <svg class="w-4 h-4 text-slate-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
            </svg>
        </div>
        <div class="grow">
            <input type="text" formControlName="website1" class="bg-slate-100 p-1 shadow-sm w-full" maxlength="128">
        </div>
    </div>
    <!-- Website 2 -->
    <div class="flex flex-row gap-2 items-center">
        <div>
            <svg class="w-4 h-4 text-slate-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
            </svg>
        </div>
        <div class="grow">
            <input type="text" formControlName="website2" class="bg-slate-100 p-1 shadow-sm w-full "maxlength="128">
        </div>
    </div>
    <!-- Website 3 -->
    <div class="flex flex-row gap-2 items-center">
        <div>
            <svg class="w-4 h-4 text-slate-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
            </svg>
        </div>
        <div class="grow">
            <input type="text" formControlName="website3" class="bg-slate-100 p-1 shadow-sm w-full" maxlength="128">
        </div>
    </div>
    <div class="flex flex-row justify-end gap-2 items-center">
        <button (click)="onCancel()" class="justify-center w-[10ch] flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
            Cancel
        </button>
        <button type="submit" [disabled]="!canSubmit()" class="justify-center w-[10ch] flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
            Save
        </button>
    </div>
</form>